import { action } from 'satcheljs';
import type { MailboxInfo } from 'owa-client-types';

export interface OpenDraftReplyFromBriefingActionMessage {
    messageId: string;
    body: string;
    mailboxInfo: MailboxInfo;
    conversationId?: string;
}

export const openDraftReplyFromBriefing: (
    messageId: string,
    body: string,
    mailboxInfo: MailboxInfo,
    conversationId?: string
) => OpenDraftReplyFromBriefingActionMessage = action(
    'OPEN_DRAFT_REPLY_FROM_BRIEFING',
    (
        messageId: string,
        body: string,
        mailboxInfo: MailboxInfo,
        conversationId?: string
    ): OpenDraftReplyFromBriefingActionMessage => ({
        messageId,
        body,
        mailboxInfo,
        conversationId,
    })
);
